{
	"add": "Añadir producto",
	"addItem": "Agregar elemento",
	"addItemName": "Item {{length}}",
	"average": "Promedio",
	"category": "Categoría",
	"categoryPlaceholder": "Categoría de producto",
	"description": "Descripción",
	"descriptionPlaceholder": "Descripción del producto",
	"edit": "Editar producto",
	"equivalentProduct": "Producto equivalente",
	"higher": "Higher",
	"max": "Max",
	"maxCount": "Cantidad máxima seleccionable",
	"min": "Min",
	"mountableProduct": "Producto compuesto",
	"name": "Nombre",
	"namePlaceholder": "Nombre del producto",
	"noCategory": "Sin categoría",
	"price": "Valor",
	"pricing": "Precios",
	"product": "Producto",
	"productPrice": "Valor del producto",
	"save": "Guardar cambios",
	"searchProduct": "Buscar por productos",
	"sku": "SKU",
	"step": "STEP {{index}}",
	"sum": "Suma",
	"title": "Título",
	"titlePlaceholder": "Step title",
	"validadeField": "Campo obligatorio",
	"zigCategory": "Zig category"
}
